import { render, staticRenderFns } from "./CompetenceEditDialog.vue?vue&type=template&id=7f385b5a"
import script from "./CompetenceEditDialog.vue?vue&type=script&lang=js"
export * from "./CompetenceEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports